import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var GlobalFooterColumn = function GlobalFooterColumn(_ref) {
  var header = _ref.header,
      children = _ref.children;
  var getClassName = getClassNameFactory(GlobalFooterColumn.displayName);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var toggleExpand = function toggleExpand() {
    setExpanded(!expanded);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "header"
    })
  }, header && /*#__PURE__*/React.createElement("p", {
    className: getClassName({
      descendantName: "title"
    })
  }, header), /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "button"
    }),
    onClick: toggleExpand,
    "aria-haspopup": true,
    "aria-expanded": expanded,
    title: "expand menu",
    "aria-label": "expand menu"
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "caret"
    })
  }, expanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)))), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "list",
      modifiers: classNames({
        expanded: expanded
      })
    })
  }, children));
};

GlobalFooterColumn.displayName = "GlobalFooterColumn";
GlobalFooterColumn.propTypes = {
  /**
   * Content, array of GlobalFooterItem
   */
  children: PropTypes.node.isRequired,

  /**
   * Colum header
   */
  header: PropTypes.string
};
export default GlobalFooterColumn;